import { Controller } from "@hotwired/stimulus";

/**
 * Expand an element via toggle button
 * @example <caption>HTML, controller registered as "expand"</caption>
 * <div data-controller="expand" data-slider-js-class-value="js">
 *   <button type="button" data-action="slider#select">Toggle</button>
 *   <div>Hello</div>
 * </div>
 */
export default class extends Controller {
  static targets = ["toggle"];
  static classes = ["js"];

  connect() {
    this.element.classList.add(this.jsClassValue || "js");
    this.toggle({ currentTarget: this.toggleTarget }, false);
  }

  /**
   * Toggle the expanded state of the target via aria-expanded
   */
  toggle(event, force = undefined) {
    const currentState =
      force !== undefined
        ? !force
        : event.currentTarget.getAttribute("aria-expanded") === "true";

    event.currentTarget.setAttribute(
      "aria-expanded",
      (!currentState).toString()
    );

    if (event.stopPropagation === "function") {
      event.stopPropagation();
    }
  }
}
